module.exports = __webpack_public_path__ + "img/dsci0084.06011ef5.jpg";